import styled from 'styled-components'

export const FontSizeFieldStyled = styled.div.attrs((props) => ({
    className: 'form-control form-control-sm bg-transparent rounded-0 border-top-0 border-start-0 border-end-0 text-light ',
}))``
